import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import * as Router from '../../router'
import * as Actions from './actions'

type OnEnter = ReduxObservable.Epic<Redux.Action, any>
const onEnter: OnEnter = (action$, store, {history}) =>
  action$.ofType(Router.ON_ENTER)
    .filter(() => history.location.pathname === '/')
    .map(store.getState)
    .mergeMap((state) => [
      Actions.fetchTotalMembers(state),
      Actions.fetchEmailActions(state),
      Actions.fetchTags(state),
    ])

export const epic = ReduxObservable.combineEpics(onEnter)



// WEBPACK FOOTER //
// ./src/pages/home/epic.ts